const headers = {
  name: "Roles",
  navigate: {
    tabs: [
      { 
        name: "Settings",
        path: "/app/settings",
      },
      {
        name: "Roles",
        path: "/app/settings/roles",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
